import React, { useState, useEffect } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";

import { PATH_DASHBOARD } from "@app/routes/paths";

import { Sidebar } from "../side-bar";
import { TopBar } from "../top-bar";

const pathToLabelMap: Record<string, string> = {
  [PATH_DASHBOARD.dashboard]: "Dashboard",
  [PATH_DASHBOARD.salesPerson]: "User",
  [PATH_DASHBOARD.brand]: "Brand",
};

const SideTopLayout = ({
  children,
  activeItem: externalActiveItem,
}: {
  children: React.ReactNode;
  activeItem?: string;
}) => {
  console.log(externalActiveItem,"externalActiveItem");
  
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(()=>{
    return localStorage.getItem("activeItem") || "Dashboard"
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

 useEffect(() => {
  const matchedLabel =
    Object.entries(pathToLabelMap).find(([path]) => {
      const normalizedPath = location.pathname.replace(/\/+$/, "");
      return normalizedPath === path || normalizedPath.startsWith(`${path}/`);
    })?.[1] || null;

  if (matchedLabel && matchedLabel !== activeItem) {
    setActiveItem(matchedLabel);
    localStorage.setItem("activeItem", matchedLabel);
  }
}, [location.pathname]);


  const handleSetActiveItem = (val:string) =>{
    setActiveItem(val);
    localStorage.setItem("activeItem", val)
  }

  return (
    <Box>
      <TopBar
        activeItem={externalActiveItem ?? activeItem}
        onMenuClick={() => setDrawerOpen(true)}
      />
      <Box display="flex" height="calc(100vh - 64px)">
        {isMobile ? (
          <Sidebar
            activeItem={activeItem}
            setActiveItem={handleSetActiveItem}
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
          />
        ) : (
          <Sidebar activeItem={activeItem} setActiveItem={handleSetActiveItem} />
        )}
        <Box
          flex={1}
          p={3}
          sx={{ overflowY: "auto", height: "100%", backgroundColor: "#f4f6f8" }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export { SideTopLayout };
